module.exports = __webpack_public_path__ + "static/media/img2.f5c9e57b.jpg";